export default __webpack_public_path__ + "media/assets/img/img_icon_title-3d02d4550bc2eefc8df7d51c78e4bc6b.svg";